(function() {
    'use strict';

    angular
        .module('app.cuentasContables')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/cuentas-contables',
                config: {
                    templateUrl: 'app/cuentasContables/cuentasContables.html',
                    controller: 'CuentasContables',
                    controllerAs: 'vm',
                    title: 'CuentasContables'
                }
            },
            {
                url: '/editar-cuenta-contable/:id?',
                config: {
                    templateUrl: 'app/cuentasContables/editarCuentaContable.html',
                    controller: 'EditarCuentaContable',
                    controllerAs: 'vm',
                    title: 'EditarCuentaContable'
                }
            }
        ];
    }
})();
